import React from 'react'
import AddressCard from '../AddressCard/AddressCard'
import OrderTracker from './OrderTracker'
import { Box, Grid } from '@mui/material'
import { deepPurple } from '@mui/material/colors'
import StarBorderIcon from '@mui/icons-material/StarBorder';

export default function OrderDetails() {
    return (
        <div className='px:5 lg:px-20'>
            <div>
                <h1 className=' font-bold text-xl py-10'>Delivery Address</h1>
                <AddressCard />
            </div>
            <div className='py-20'>
                <OrderTracker activeStep={3} />
            </div>
            <Grid className=' space-y-5 mb-10' container>

                {[1,1,1,1].map((item)=><Grid item container className=' shadow-xl rounded-md p-5 border ' sx={{ alignItems: "center", justifyContent: 'space-between' }}>
                    <Grid item xs={6}>
                        <div className=' flex items-center space-x-2'>
                            <img className='w-[5rem] h-[5rem] object-cover object-top' src='https://i2.wp.com/pt2000.com.vn/wp-content/uploads/2022/05/AD-T10-0TI00-450K.jpg' alt='PT2000' />
                            <div className=' space-y-2 ml-5'>
                                <p>Áo đầm nữ siêu đẹp</p>
                                <p>Mã sản phẩm: AD-019-0DE00</p>
                                <p>Giá:500,000đ</p>
                            </div>
                        </div>
                    </Grid>
                    <Grid item>
                        <Box sx={{color:deepPurple[500]}}>
                            <StarBorderIcon sx={{fontSize:"2rem"}} className='px-2'  />
                            <span>Rate & Review Product</span>
                        </Box>
                    </Grid>
                </Grid>)}
                
            </Grid>

        </div>
    )
}
